/* eslint-disable max-len */
export const query = `
    query GetWebProfileOverview(
        $profileId: String
        $effectiveDate: String
        $locale: String
        $annotationFilterProperty: String = "useForPdfProfiles"
        $includeAllProfiles: Boolean! = true
        $includeHistoricalHoldings: Boolean! = true
        $includeUnderlyingFundPerformance: Boolean! = true
        $includeFundSeriesPerformance: Boolean! = true
    ) {
        allProfiles: webProfiles(locale: $locale, take: 9999) @include(if: $includeAllProfiles) {
            entityId
            fundName
            sortOrder
            isInactive
            documents {
                entityId
                code
                name
                shortName
                url
                title
                description
                thumbnailUrl
                tags
                sortOrder
            }
            webProfileSalesOptions {
                entityId
                salesOption {
                    entityId
                    productGroup {
                        entityId
                        name
                        shortName
                        fullName
                        sortOrder
                    }
                    product {
                        entityId
                        name
                        shortName
                        fullName
                        sortOrder
                    }
                    series {
                        entityId
                        seriesType {
                            entityId
                            name
                            fullName
                            shortName
                            sortOrder
                        }
                        fund {
                            entityId
                            shortName
                            fullName
                            productGroup {
                                entityId
                                name
                                shortName
                                fullName
                                sortOrder
                            }
                            product {
                                entityId
                                name
                                shortName
                                fullName
                                sortOrder
                            }
                        }
                    }
                }
            }
        }

        globalWebProfileAnnotations: webProfileAnnotations(
            locale: $locale
            filters: [
                { propertyId: $annotationFilterProperty, operator: "=", propertyValue: "true" }
                { propertyId: "isGlobal", operator: "=", propertyValue: "true" }
            ]
        ) {
            ...webProfileAnnotationFields
        }

        globalFundAnnotations: fundAnnotations(
            locale: $locale
            filters: [
                { propertyId: $annotationFilterProperty, operator: "=", propertyValue: "true" }
                { propertyId: "isGlobal", operator: "=", propertyValue: "true" }
            ]
        ) {
            ...fundAnnotationFields
        }

        globalSeriesAnnotations: seriesAnnotations(
            locale: $locale
            filters: [
                { propertyId: $annotationFilterProperty, operator: "=", propertyValue: "true" }
                { propertyId: "isGlobal", operator: "=", propertyValue: "true" }
            ]
        ) {
            ...seriesAnnotationFields
        }
        webProfiles(entityId: $profileId, effectiveDate: $effectiveDate, locale: $locale, take: 1) {
            entityId
            fundName
            sortOrder

            title
            description
            pdfFilename

            isInactive

            equityCharacteristic
            fixedIncomeCharacteristic
            className
            annotations(
                filters: [
                    { propertyId: $annotationFilterProperty, operator: "=", propertyValue: "true" }
                ]
            ) {
                ...webProfileAnnotationFields
            }

            documents {
                entityId
                code
                name
                shortName
                url
                title
                description
                thumbnailUrl
                tags
                sortOrder
            }

            webProfileSalesOptions(take: 1) {
                salesOption {
                    series {
                        ...primarySeriesFields
                        annotations(
                            filters: [
                                {
                                    propertyId: $annotationFilterProperty
                                    operator: "="
                                    propertyValue: "true"
                                }
                            ]
                        ) {
                            ...seriesAnnotationFields
                        }
                        fund {
                            entityId
                            fullName
                            portfolioManager
                            subAdvisor
                            advisor
                            exchange
                            exchangeName
                            management
                            managementDescription
                            managementUrl
                            incentiveFee
                            earlyRedemptionFee

                            timeHorizon {
                                entityId
                            }

                            aum
                            aumDate
                            investmentObjective
                            investmentStrategy
                            investmentPhilosophy
                            whyInvest
                            whatDoesTheFundInvestIn
                            investmentStyle {
                                entityId
                                name
                            }
                            broker
                            administrator
                            auditor
                            lawyer
                            assetClass {
                                entityId
                                name
                                shortName
                                fullName
                                sortOrder
                            }
                            fundamentalMetrics(take: 1, sortDirection: "D") {
                                ...fundamentalMetricsFields
                            }
                            fundCategory {
                                entityId
                                name
                                shortName
                                fullName
                                sortOrder
                            }
                            productGroup {
                                entityId
                                name
                                shortName
                                fullName
                                sortOrder
                            }
                            product {
                                entityId
                                name
                                shortName
                                fullName
                                sortOrder
                            }

                            cifscCategory {
                                ...cifscCategoryFields
                            }
                            morningStarCategory {
                                entityId
                                name
                                shortName
                                fullName
                                sortOrder
                            }
                            riskRating {
                                ...riskRatingFields
                            }

                            annotations(
                                filters: [
                                    {
                                        propertyId: $annotationFilterProperty
                                        operator: "="
                                        propertyValue: "true"
                                    }
                                ]
                            ) {
                                ...fundAnnotationFields
                            }
                            series {
                                entityId
                                ticker
                                cusip
                                isin
                                sedol
                                isInactive

                                inceptionDate
                                minimumInitialInvestment
                                minimumSubsequentInvestment
                                minimumPac
                                minimumSubsequentPAC
                                minimumInitialInvestmentRRSP
                                minimumSubsequentInvestmentRRSP
                                minimumInvestment
                                minimumInvestmentPAC
                                minimumInitialInvestmentAccredited
                                minimumInitialInvestmentQualified
                                registeredPlanEligibility
                                dividendReinvestmentPlanEligibility

                                rebalancingFrequency
                                rebalancingThreshold

                                aum
                                aumDate

                                seriesType {
                                    ...seriesTypeFilds
                                }
                                currency {
                                    ...currencyFields
                                }

                                mPowerCode
                                mPowerClass

                                fundCodes: salesOptions {
                                    entityId
                                    fundservCode
                                    ifastClass
                                    priceCode
                                    companyPrefix

                                    seriesClass {
                                        entityId
                                        name
                                    }

                                    fundStatus {
                                        entityId
                                        name
                                        shortName
                                        sortOrder
                                    }

                                    line {
                                        entityId
                                        name
                                    }
                                    newSLICodes
                                    minimumInitialInvestment
                                    fundFeeRate
                                    fundservCode
                                    scBackEndComm
                                    scNoLoadComm

                                    loadType {
                                        ...loadTypeFields
                                    }
                                    product {
                                        entityId
                                        name
                                        shortName
                                        fullName
                                        sortOrder
                                    }
                                    productGroup {
                                        entityId
                                        name
                                        shortName
                                        fullName
                                        sortOrder
                                    }

                                    annotations(
                                        filters: [
                                            {
                                                propertyId: $annotationFilterProperty
                                                operator: "="
                                                propertyValue: "true"
                                            }
                                        ]
                                    ) {
                                        ...salesOptionAnnotationFields
                                    }
                                }

                                fundStatus {
                                    entityId
                                    name
                                    shortName
                                    sortOrder
                                }

                                fees(sortDirection: "d", take: 1) {
                                    ...feesFields
                                }
                                performance: salesOptions(take: 1)
                                    @include(if: $includeFundSeriesPerformance) {
                                    _performance_growth(granularity: MONTHLY) {
                                        date
                                        value
                                    }
                                    annualPerformance(take: 1, sortDirection: "D") {
                                        ...annualPerformanceFields
                                    }
                                    compoundPerformance(take: 1, sortDirection: "D") {
                                        ...compoundPerformanceFields
                                    }

                                    monthlyDistributions: _performance_monthly_distributions(
                                        numberOfMonths: 12
                                    ) {
                                        effectiveDate
                                        distributions {
                                            effectiveDate
                                            distributionAmount
                                        }
                                    }
                                }
                                monthlyDistributionBreakdowns(sortDirection: "D", take: 12) {
                                    effectiveDate
                                    exDate
                                    declarationDate
                                    payDate
                                    recordDate
                                    incomePortion
                                    interestPortion
                                    dividendPortion
                                    capitalGainsPortion
                                    returnOfCapitalPortion
                                    reinvestmentPrice
                                    cashPortion
                                    distributionAmount
                                }
                            }
                            benchmark1 {
                                ...benchmarkFields
                                prices {
                                    effectiveDate
                                    navps
                                }
                                fundamentalMetrics(take: 1, sortDirection: "D") {
                                    ...fundamentalMetricsFields
                                }
                                annualPerformance(take: 1, sortDirection: "D") {
                                    ...annualPerformanceFields
                                }
                                compoundPerformance(take: 1, sortDirection: "D") {
                                    ...compoundPerformanceFields
                                }
                            }
                            benchmark2 {
                                ...benchmarkFields
                                fundamentalMetrics(take: 1, sortDirection: "D") {
                                    ...fundamentalMetricsFields
                                }
                            }
                            benchmark3 {
                                ...benchmarkFields
                            }

                            underlyingFund {
                                entityId
                                _performance_growth(granularity: MONTHLY)
                                    @include(if: $includeUnderlyingFundPerformance) {
                                    date
                                    value
                                }
                                annualPerformance(take: 1, sortDirection: "D")
                                    @include(if: $includeUnderlyingFundPerformance) {
                                    ...annualPerformanceFields
                                }
                                compoundPerformance(take: 1, sortDirection: "D")
                                    @include(if: $includeUnderlyingFundPerformance) {
                                    ...compoundPerformanceFields
                                }
                            }

                            portfolios(sortDirection: "d", take: 1) {
                                entityId
                                effectiveDate # Holdings effective date (Composition table timestamp)
                                underlyingFund
                                cashEquivalents
                                numberOfBondPositions
                                numberOfEquityFunds
                                numberOfEquityPositions
                                numberOfFixedIncomeFunds
                                numberOfHoldings
                                numberOfOtherPositions
                                numberOfPositions
                                numberOfTotalFunds
                                numberOfCashPositions
                                numberOfSpecialtyFunds
                                top10EquityTotal
                                top10BondTotal
                                averageCoupon
                                averageDividendYield
                                priceEarnings
                                priceBook

                                topHoldingsType {
                                    entityId
                                    name
                                }

                                numberOfDeals
                                numberOfSpacs
                                averageMarketCap {
                                    entityId
                                    name
                                }
                                averageMarketCapClientSource
                                yieldToMaturity
                                modifiedDuration
                                averageTerm
                                averageCreditQuality {
                                    entityId
                                    name
                                    sortOrder
                                }

                                # allocations
                                assetMixBreakdowns {
                                    assetClass
                                    min
                                    max
                                    strategicBenchmark
                                    currentTacticalMix
                                }
                                preferredShareAllocations {
                                    ...holdingAllocationFields
                                }
                                underlyingFundCompanyBreakdowns {
                                    ...holdingAllocationFields
                                }
                                underlyingFundHoldings {
                                    ...holdingAllocationFields
                                }
                                canadianEquityBreakdown {
                                    ...topHoldingAllocationFields
                                }
                                fixedIncomeBreakdown {
                                    ...topHoldingAllocationFields
                                }
                                foreignEquityBreakdown {
                                    ...topHoldingAllocationFields
                                }

                                specialtyBreakdown {
                                    ...topHoldingAllocationFields
                                }

                                specialtyCategoryBreakdown {
                                    ...holdingAllocationFields
                                }

                                assetGroupAllocations {
                                    ...assetAllocationFields
                                }
                                assetSubGroupAllocations {
                                    ...assetAllocationFields
                                }
                                assetClassAllocations {
                                    ...assetAllocationFields
                                }
                                assetAllocations {
                                    ...assetAllocationFields
                                }
                                targetAssetAllocations {
                                    holding
                                    allocation
                                }
                                bondTermAllocations {
                                    bondTerm {
                                        entityId
                                        name
                                    }
                                    holding
                                    allocation
                                    allocationLong
                                    allocationShort
                                    allocationGross
                                    benchmarkAllocation
                                }
                                creditQualityRateAllocations {
                                    creditQualityRating {
                                        entityId
                                        name
                                        sortOrder
                                    }
                                    holding
                                    allocation
                                    allocationLong
                                    allocationShort
                                    allocationGross
                                    benchmarkAllocation
                                }
                                currencyAllocations {
                                    currency {
                                        ...currencyFields
                                    }
                                    allocation
                                }
                                fixedIncomeTypeAllocations {
                                    assetType {
                                        entityId
                                        name
                                    }
                                    holding
                                    allocation
                                    allocationLong
                                    allocationShort
                                    allocationGross
                                    benchmarkAllocation
                                }
                                geographicAllocations {
                                    country {
                                        entityId
                                        name
                                        iso3166_1_alpha2code
                                        iso3166_1_alpha3code
                                    }
                                    holding
                                    allocation
                                    allocationLong
                                    allocationShort
                                    allocationGross
                                    benchmarkAllocation
                                }
                                marketCapAllocations {
                                    marketCap {
                                        entityId
                                        name
                                    }
                                    holding
                                    allocation
                                    allocationLong
                                    allocationShort
                                    allocationGross
                                    benchmarkAllocation
                                }
                                top10Holdings {
                                    ...holdingAllocationFields
                                }
                                sectorAllocations {
                                    sector {
                                        entityId
                                        name
                                    }
                                    holding
                                    allocation
                                    allocationLong
                                    allocationShort
                                    allocationGross
                                    benchmarkAllocation
                                }

                                globalEquityBreakdown {
                                    ...topHoldingAllocationFields
                                }

                                unitedStatesEquityBreakdown {
                                    ...topHoldingAllocationFields
                                }

                                internationalEquityBreakdown {
                                    ...topHoldingAllocationFields
                                }

                                canadianEquityCategoryBreakdown {
                                    ...holdingAllocationFields
                                }

                                canadianEquityPortfolioBreakdown {
                                    ...topHoldingAllocationFields
                                }

                                bondPortfolioBreakdown {
                                    ...topHoldingAllocationFields
                                }

                                globalEquityPortfolioBreakdown {
                                    ...topHoldingAllocationFields
                                }

                                fixedIncomeCategoryBreakdown {
                                    ...holdingAllocationFields
                                }

                                fixedIncomeHoldingsBreakdown {
                                    ...topHoldingAllocationFields
                                }

                                foreignEquityCategoryBreakdown {
                                    ...holdingAllocationFields
                                }

                                foreignIncomeHoldingsBreakdown {
                                    ...topHoldingAllocationFields
                                }

                                top10HoldingsOfLargestFundHolding {
                                    ...holdingAllocationFields
                                }

                                topBondHoldings {
                                    ...holdingAllocationFields
                                }

                                topEquityHoldings {
                                    ...holdingAllocationFields
                                }

                                topHoldingsMixed {
                                    ...holdingAllocationFields
                                }

                                topHoldingsPlusCash {
                                    ...holdingAllocationFields
                                }
                                riskAllocations {
                                    ...holdingAllocationFields
                                }
                                securityTypeAllocations {
                                    ...holdingAllocationFields
                                }
                                exposureAllocations {
                                    entityId
                                    exposureType {
                                        entityId
                                        name
                                    }
                                    holding
                                    allocation
                                    allocationLong
                                    allocationShort
                                    allocationGross
                                    benchmarkAllocation
                                }
                                dollarAllocations {
                                    ...holdingAllocationFields
                                }

                                strategyWeightingsAllocations {
                                    ...strategyWeightingsAllocationsFields
                                }

                                cashTypeAllocations {
                                    assetType {
                                        entityId
                                        name
                                    }
                                    holding
                                    allocation
                                    allocationLong
                                    allocationShort
                                    allocationGross
                                    benchmarkAllocation
                                }

                                # morningstar details
                                globalBondSectorLevel1Breakdowns {
                                    holding
                                    allocation
                                    allocationLong
                                    allocationShort
                                    allocationGross
                                    benchmarkAllocation
                                    typeDescription: msGlobalBondSector {
                                        entityId
                                        name
                                    }
                                }

                                globalBondSectorLevel2Breakdowns {
                                    holding
                                    allocation
                                    allocationLong
                                    allocationShort
                                    allocationGross
                                    benchmarkAllocation
                                    typeDescription: msGlobalBondSector {
                                        entityId
                                        name
                                    }
                                }
                                globalBondSectorLevel3Breakdowns {
                                    holding
                                    allocation
                                    allocationLong
                                    allocationShort
                                    allocationGross
                                    benchmarkAllocation
                                    typeDescription: msGlobalBondSector {
                                        entityId
                                        name
                                    }
                                }

                                globalStockSectorBreakdowns {
                                    holding
                                    allocation
                                    allocationLong
                                    allocationShort
                                    allocationGross
                                    benchmarkAllocation
                                    typeDescription: msGlobalStockSector {
                                        entityId
                                        name
                                    }
                                }

                                morningstarAssetBreakdowns {
                                    holding
                                    allocation
                                    allocationLong
                                    allocationShort
                                    allocationGross
                                    benchmarkAllocation
                                    typeDescription: msAssetType {
                                        entityId
                                        name
                                    }
                                }

                                morningstarRegionBreakdowns {
                                    holding
                                    allocation
                                    allocationLong
                                    allocationShort
                                    allocationGross
                                    benchmarkAllocation
                                    typeDescription: msRegion {
                                        entityId
                                        name
                                    }
                                }

                                morningstarEquityStyleBreakdowns {
                                    holding
                                    allocation
                                    allocationLong
                                    allocationShort
                                    allocationGross
                                    benchmarkAllocation
                                    typeDescription: msEquityStyleboxMapping {
                                        entityId
                                        name
                                    }
                                }

                                morningstarBondStyleBreakdowns {
                                    holding
                                    allocation
                                    allocationLong
                                    allocationShort
                                    allocationGross
                                    benchmarkAllocation
                                    typeDescription: msBondStyleboxMapping {
                                        entityId
                                        name
                                    }
                                }

                                morningstarCreditQualityBreakdown {
                                    holding
                                    allocation
                                    allocationLong
                                    allocationShort
                                    allocationGross
                                    benchmarkAllocation
                                    typeDescription: msCreditQualityType {
                                        entityId
                                        name
                                    }
                                }
                            }
                            historicalPortfolios: portfolios(sortDirection: "d", take: 60)
                                @include(if: $includeHistoricalHoldings) {
                                effectiveDate
                                ...historicalPortfolioAllocationFields
                            }
                            fundManagers {
                                ...fundManagerFields
                            }
                            articles {
                                ...articleFields
                            }

                            lipperFundAwards
                        }

                        monthlyDistributionBreakdowns(sortDirection: "D", take: 60) {
                            effectiveDate
                            exDate
                            declarationDate
                            payDate
                            recordDate
                            incomePortion
                            interestPortion
                            dividendPortion
                            capitalGainsPortion
                            returnOfCapitalPortion
                            reinvestmentPrice
                            cashPortion
                            distributionAmount
                        }

                        annualDistributionBreakdowns {
                            effectiveDate
                            interestPortion
                            dividendPortion
                            capitalGainsPortion
                            returnOfCapitalPortion
                            totalDistribution
                            foreignNonBusinessPortion
                            ineligibleCdnDividendPortion
                            eligibleCdnDividendPortion
                            incomePortion
                            foreignIncomePortion
                            foreignTaxPortion
                        }
                    }
                    ...salesOptionPerformanceFields
                }
            }

            # Flags used to show and hide various holdings contexts
            # capturing this in a fragment would break CustomWebProfile inheritance
            top10HoldingContext
            showGeographicAllocation: geographicAllocation
            showSectorAllocation: sectorAllocation
            showCreditQualityRateAllocation: creditQualityRateAllocation
            showAssetClassAllocation: assetClassAllocation
            showTargetAssetAllocation: targetAssetAllocation
            showCurrencyAllocation: currencyAllocation
            showBondTermAllocation: bondTermAllocation
            showUnderlyingFundHolding: underlyingFundHolding
            showRiskAllocation: riskAllocation
            showExposureAllocation: exposureAllocation
            showTop10Holding: top10Holding
            showFixedIncomeTypeAllocation: fixedIncomeTypeAllocation
            showCashTypeAllocation: cashTypeAllocation
            showDollarAllocation: dollarAllocation
            showSecurityTypeAllocation: securityTypeAllocation
            showMarketCapAllocation: marketCapAllocation
            showPreferredShareAllocation: preferredShareAllocation
            showUnderlyingFundCompanyBreakdowns: underlyingFundCompanyBreakdown
        }
    }

    fragment benchmarkFields on Benchmark {
        entityId
        name
        isBlendedBenchmark
    }

    fragment fundamentalMetricsFields on FundamentalMetric {
        effectiveDate
        yieldToWorst
        weightedAverageModifiedDuration
        creditRatingScore
        creditRating
        issuers
        avgCreditQuality
        currentYield
        duration
        activeShare
        activeShareDate
        dividendYield
        marketCap
        equityStyleFactorDivYld
        equityStyleFactorPriceEarnings
        priceEarningsRatio
        equityStyleFactorPriceBook
        priceBookRatio
        equityStyleFactorPriceCashFlow
        priceCashFlowRatio
        equityStyleFactorPriceSales
        priceSalesRatio
        roe
        yieldToMaturity
        averageLifeToMaturity
        distributionYield
        activeShareEtfBenchmarkProxy
        targetRange
        holdRange
        reconstitution
        correlationToFund
    }

    fragment seriesTypeFilds on SeriesType {
        entityId
        name
        shortName
        fullName
        description
        sortOrder
    }

    fragment loadTypeFields on LoadType {
        entityId
        name
        shortName
        code
        sortOrder
    }

    fragment fundAnnotationFields on FundAnnotation {
        id: entityId
        text
        textHtml
        textTargetId
        markerTargetId
        markerType
        marker
        tags
    }

    fragment webProfileAnnotationFields on WebProfileAnnotation {
        id: entityId
        text
        textHtml
        textTargetId
        markerTargetId
        markerType
        marker
        tags
    }

    fragment seriesAnnotationFields on SeriesAnnotation {
        id: entityId
        text
        textHtml
        textTargetId
        markerTargetId
        markerType
        marker
        tags
    }

    fragment salesOptionAnnotationFields on SalesOptionAnnotation {
        id: entityId
        text
        textHtml
        textTargetId
        markerTargetId
        markerType
        marker
        tags
    }

    fragment historicalPortfolioAllocationFields on HoldingsPortfolio {
        geographicAllocations {
            country {
                entityId
                name
                iso3166_1_alpha2code
                iso3166_1_alpha3code
            }
            holding
            allocation
            allocationLong
            allocationShort
            allocationGross
            benchmarkAllocation
        }

        fixedIncomeTypeAllocations {
            assetType {
                entityId
                name
            }
            holding
            allocation
            allocationLong
            allocationShort
            allocationGross
            benchmarkAllocation
        }

        sectorAllocations {
            sector {
                entityId
                name
            }
            holding
            allocation
            allocationLong
            allocationShort
            allocationGross
            benchmarkAllocation
        }

        assetClassAllocations {
            ...assetAllocationFields
        }

        cashTypeAllocations {
            assetType {
                entityId
                name
            }
            holding
            allocation
            allocationLong
            allocationShort
            allocationGross
            benchmarkAllocation
        }

        bondTermAllocations {
            bondTerm {
                entityId
                name
            }
            holding
            allocation
            allocationLong
            allocationShort
            allocationGross
            benchmarkAllocation
        }

        creditQualityRateAllocations {
            creditQualityRating {
                entityId
                name
                sortOrder
            }
            holding
            allocation
            allocationLong
            allocationShort
            allocationGross
            benchmarkAllocation
        }
    }

    fragment strategyWeightingsAllocationsFields on StrategyWeightingsAllocation {
        strategyWeighting {
            entityId
            name
        }
        holding
        allocation
        allocationLong
        allocationShort
        allocationGross
        benchmarkAllocation
    }

    fragment assetAllocationFields on AssetAllocation {
        assetType {
            entityId
            name
        }
        holding
        allocation
        allocationLong
        allocationShort
        allocationGross
        benchmarkAllocation
    }

    fragment holdingAllocationFields on HoldingAllocation {
        holding
        allocation
        allocationLong
        allocationShort
        allocationGross
        benchmarkAllocation
    }

    fragment topHoldingAllocationFields on TopHoldingAllocation {
        holding
        allocation
        allocationLong
        allocationShort
        allocationGross
        benchmarkAllocation
        top5UnderlyingFundHoldings {
            holding
            allocation
            allocationLong
            allocationShort
            allocationGross
            benchmarkAllocation
        }
    }

    fragment managerFields on Manager {
        entityId
        firstName
        middleName
        lastName
        title
        fullName
        company
        companyUrl
        education
        biography
        industryExperienceSince
        biographyUrl
        managerCommentary
        printTitle

        articles1 {
            ...articleFields
        }
        articles2 {
            ...articleFields
        }
        articles3 {
            ...articleFields
        }
        articles4 {
            ...articleFields
        }
    }

    fragment articleAuthorFields on Manager {
        entityId
        firstName
        middleName
        lastName
        title
        fullName
    }

    fragment fundManagerFields on FundManager {
        id
        effectiveDate
        leadOrder
        titleOnFund
        startDate
        strategy
        manager {
            ...managerFields
        }
    }

    fragment feesFields on Fees {
        effectiveDate
        mer
        isEstimatedMer
        managementFee
        insuranceFee
        adminFee
        ter
        fixedAdminFee
        hst
    }

    fragment riskRatingFields on RiskRating {
        entityId
        name
        sortOrder
    }

    fragment annualPerformanceFields on AnnualPerformance {
        effectiveDate
        _1990
        _1991
        _1992
        _1993
        _1994
        _1995
        _1996
        _1997
        _1998
        _1999
        _2000
        _2001
        _2002
        _2003
        _2004
        _2005
        _2006
        _2007
        _2008
        _2009
        _2010
        _2011
        _2012
        _2013
        _2014
        _2015
        _2016
        _2017
        _2018
        _2019
        _2020
        _2021
        _2022
        _2023
        _2024
        _2025
        _2026
        _2027
        _2028
        _2029
        _2030
    }

    fragment compoundPerformanceFields on CompoundPerformance {
        effectiveDate
        p1mo
        p3mo
        p6mo
        pytd
        p1yr
        p2yr
        p3yr
        p4yr
        p5yr
        p7yr
        p8yr
        p9yr
        p10yr
        p15yr
        psi
        psiB1
        psiB2
        psiB3
        best3mo
        best3moEffectiveDate
        worst3mo
        worst3moEffectiveDate
        guaranteedValuePerUnit
        distributionYield12mo
        trailingYield12mo
        cumulativePsi
        percentPositiveMo
        percentPositiveMoB1
        percentPositiveMoB2
    }

    fragment salesOptionPerformanceFields on SalesOption {
        entityId

        _performance_dailyPerformance {
            effectiveDate
            navPS
            price
            d1EffectiveDate
            d1NavPs
            d1Amt
            d1Pct
            d1Price
            d1PriceChangeAmt
            d1PriceChangePct
            d1Performance
            d1AnnualizedPerformance
            d7EffectiveDate
            d7NavPs
            d7Amt
            d7Pct
            d7Price
            d7PriceChangeAmt
            d7PriceChangePct
            d7Performance
            d7AnnualizedPerformance
            d30EffectiveDate
            d30NavPs
            d30Amt
            d30Pct
            d30Price
            d30PriceChangeAmt
            d30PriceChangePct
            d30Performance
            d30AnnualizedPerformance
            ytdEffectiveDate
            ytdNavPs
            ytdAmt
            ytdPct
            ytdPrice
            ytdPriceChangeAmt
            ytdPriceChangePct
            ytdPerformance
            ytdAnnualizedPerformance
        }

        _performance_growth(granularity: MONTHLY) {
            date
            value
        }

        annualPerformance(take: 1, sortDirection: "D") {
            ...annualPerformanceFields
        }
        compoundPerformance(take: 1, sortDirection: "D") {
            ...compoundPerformanceFields
        }

        latestPriceRecord: prices(take: 31, sortDirection: "D") {
            entityId
            effectiveDate
            navps
            totalNetAssets
            splitRatio
            accrualAmount
            unitsOutstanding
            primaryListingPrice
            premiumDiscountPct
            exDate
            declarationDate
            payDate
            recordDate
            distributionAmount
            incomePortion
            interestPortion
            dividendPortion
            capitalGainsPortion
            returnOfCapitalPortion
            yield7Day
        }

        prices(take: 36500) {
            effectiveDate
            navps
            distributionAmount
            incomePortion
            interestPortion
            dividendPortion
            capitalGainsPortion
            returnOfCapitalPortion
        }

        annualDistributions: _performance_distributions(granularity: ANNUAL) {
            effectiveDate
            distributions {
                effectiveDate
                distributionAmount
                capitalGainsPortion
                dividendPortion
                incomePortion
                interestPortion
                returnOfCapitalPortion
            }
        }

        riskMetrics(take: 1, sortDirection: "D") {
            entityId
            effectiveDate
            r3yrStartDate
            r3yrAnnualizedSTDev
            r3yrAnnualizedReturn
            r3yrMaxDrawdown
            r3yrMaxDrawdownDate
            r3yrPeakValue
            r3yrPeakValueDate
            r3yrB1Stdev
            r3yrB1SharpRatio
            r3yrB1InformationRatio
            r3yrB1Beta
            r3yrB1RSquared
            r3yrB1Alpha
            r3yrB1AnnualizedStdev
            r3yrB1AnnualizedReturn
            r3yrB1UpsideCapture
            r3yrB1DownsideCapture
            r3yrB1SharpRatioOfBenchmark
            r3yrAnnualizedTrackingError
            r3yrB1TargetRateAnnualizedSortinoRatio
            r3yrTargetRateAnnualizedSortinoRatio

            r5yrStartDate
            r5yrAnnualizedSTDev
            r5yrAnnualizedReturn
            r5yrMaxDrawdown
            r5yrMaxDrawdownDate
            r5yrPeakValue
            r5yrPeakValueDate
            r5yrB1Stdev
            r5yrB1SharpRatio
            r5yrB1InformationRatio
            r5yrB1Beta
            r5yrB1RSquared
            r5yrB1Alpha
            r5yrB1AnnualizedStdev
            r5yrB1AnnualizedReturn
            r5yrB1UpsideCapture
            r5yrB1DownsideCapture
            r5yrB1SharpRatioOfBenchmark
            r5yrAnnualizedTrackingError
            r5yrB1TargetRateAnnualizedSortinoRatio
            r5yrTargetRateAnnualizedSortinoRatio

            r10yrStartDate
            r10yrAnnualizedSTDev
            r10yrAnnualizedReturn
            r10yrMaxDrawdown
            r10yrMaxDrawdownDate
            r10yrPeakValue
            r10yrPeakValueDate
            r10yrB1Stdev
            r10yrB1SharpRatio
            r10yrB1InformationRatio
            r10yrB1Beta
            r10yrB1RSquared
            r10yrB1Alpha
            r10yrB1AnnualizedStdev
            r10yrB1AnnualizedReturn
            r10yrB1UpsideCapture
            r10yrB1DownsideCapture
            r10yrB1SharpRatioOfBenchmark
            r10yrTargetRateAnnualizedSortinoRatio
            r10yrB1TargetRateAnnualizedSortinoRatio

            rsiStartDate
            rsiAnnualizedSTDev
            rsiAnnualizedReturn
            rsiMaxDrawdown
            rsiMaxDrawdownDate
            rsiPeakValue
            rsiPeakValueDate
            rsiB1Average
            rsiStdev
            rsiB1Stdev
            rsiB1SharpRatio
            rsiB1InformationRatio
            rsiB1SharpRatioOfBenchmark
            rsiB1Beta
            rsiB1RSquared
            rsiB1Alpha
            rsiB1AnnualizedStdev
            rsiB1AnnualizedReturn
            rsiB1UpsideCapture
            rsiB1DownsideCapture
            rsiB1SharpRatioOfBenchmark
            rsiB1MaxDrawdown
            rsiB1MaxDrawdownDate
            rsiAnnualizedTrackingError
            rsiB1TargetRateAnnualizedSortinoRatio
            rsiTargetRateAnnualizedSortinoRatio
            rsiB1PeakValue
            rsiB1PeakValueDate
            rsiB2AnnualizedReturn
            rsiB2MaxDrawdown
            rsiB2Stdev
            rsiB2SharpRatioOfBenchmark
        }
    }

    fragment cifscCategoryFields on CifscCategory {
        name
        description
        geographicRegion
        sortOrder
    }

    fragment currencyFields on Currency {
        entityId
        name
        iso4217alpha
        iso4217num
    }

    fragment morningStarSeriesRatingsFields on MorningStarSeriesRating {
        entityId
        effectiveDate
        overAllRating
        overAllNumFund
        _1moRating
        _3moRating
        _6moRating
        _1yrRating
        _3yrRating
        _5yrRating
        _10yrRating
        overAllQuartile
        _1moQuartile
        _3moQuartile
        _6moQuartile
        _1yrQuartile
        _3yrQuartile
        _5yrQuartile
        _10yrQuartile
        equityStyle
        fixedIncomeStyle
        numFund1mo
        numFund3mo
        numFund6mo
        numFund1yr
        numFund3yr
        numFund5yr
        numFund10yr
        portfolioDate
        portfolioNumberofHolding
    }

    fragment primarySeriesFields on Series {
        entityId
        inceptionDate

        ticker
        cusip
        isin
        sedol
        whyInvest

        qrCodeUrl

        fees(sortDirection: "d", take: 1) {
            ...feesFields
        }
        fundStatus {
            entityId
            name
            shortName
            sortOrder
        }
        seriesType {
            ...seriesTypeFilds
        }

        index
        targetDistribution
        performanceFee
        performanceResetDate
        hurdleRate
        marketLiquidity
        shareClassType
        currency {
            ...currencyFields
        }
        liquidationDate
        minimumInitialInvestment

        shareClassType
        inceptionDate
        liquidationDate
        liquidationReason {
            entityId
            name
        }
        minimumInitialInvestment
        minimumSubsequentInvestment
        minimumPac
        minimumSubsequentPAC
        minimumInitialInvestmentRRSP
        minimumSubsequentInvestmentRRSP
        minimumInvestment
        minimumInvestmentPAC
        minimumInitialInvestmentAccredited
        minimumInitialInvestmentQualified

        isNewSeries
        isOpenToNewInvestments
        isCurrencyHedged
        isLeveraged
        isReferenceShareClass
        isPublic
        hasHighWatermark
        highWatermarkPercent
        highWatermarkAmount
        highWatermarkDescription
        highWatermarkPeriodicalReset
        highWatermarkResetFrequency {
            entityId
            name
        }
        hurdleRate
        targetDistribution
        rebalancingFrequency
        rebalancingThreshold
        marketLiquidity
        isForRetailInvestorsOnly
        investmentObjective
        investmentStrategy
        investmentPhilosophy
        investmentHighlights
        totalNetAssetValue
        totalGrossAssetValue
        sharesOutstanding
        trailingCommission
        distributionFrequency {
            entityId
            name
        }
        distributions
        maturityDeathBenefit
        rrspEligibility
        registeredPlanEligibility
        dividendReinvestmentPlanEligibility
        incomeDistributionFrequency {
            entityId
            name
        }
        capitalGainsDistributionFrequency {
            entityId
            name
        }
        monthEndRecords(sortDirection: "D", take: 1) {
            entityId
            effectiveDate
            aum
            yield7day
        }
        yield7day
        yield12Month
        fundataAwardWinner
        listedLegalStructure {
            entityId
            name
        }
        managementFeeReductions {
            entityId
            tierName
            tierValue
            sortOrder
        }
        morningStarSeriesRatings(take: 1, sortDirection: "d") {
            ...morningStarSeriesRatingsFields
        }
    }

    fragment articleFields on Article {
        entityId
        effectiveDate
        author1 {
            ...articleAuthorFields
        }
        author2 {
            ...articleAuthorFields
        }
        author3 {
            ...articleAuthorFields
        }
        author4 {
            ...articleAuthorFields
        }
        publicationDate
        title
        introduction
        body
        bodyUrl
    }
`;

export const transform = ``;
